<template src='./index.html'></template>
<script>
import { getdata } from './data.js';
import dbmxx from "./dbmxx/index.vue";
import { comMapping } from '@/components/util/Function/comMapping';
import addgs from '../../../common/ywlxgz/addzt/addgs/index.vue';
import {
    queryCompanyShuibDict,
} from '../../../../api/Draftgeneration.js';
import {
    contrastSettingPageQuery,saveSetting,querySetCompany,updateSetting,deleteSetting
} from '../../../../api/contrastSetting.js';
export default {
    components: { addgs, dbmxx },
    name: 'sbbdsz',
    data: function() {
        return {
            tablekey: 0,
            overlength: 0,
            searchdata: getdata().searchdata,
            searchlist: getdata().searchlist,
            formlist: getdata().formlist,
            comHeadData: getdata().comHeadData,
            filterSearchlist: [],
            outlist: [],
            headData: getdata().headData,
            pagination: getdata().pagination,
            suosq: this.$getdefultMonth(),
            tableData: [],
            comTableData: [],
            searchdiag: false,
            setdiag: false,
            ywgzpg: false,
            formdata:getdata().formdata,
            shuizFormat: [],
            sfmr: comMapping.$flag,
            ztid: 0,
            ywgzData: {},
            ywzx: "0",
            childrenTitle: "",
            pageType: "0",
            gsdiag: false,
            wikiType: '0',
            mxdiag: false,
            mxid: "",
            mxname: "",
            mxShuizId: "",
            mxShuizName: "",
        };
    },
    mounted() {
    },
    created() {
        this.init();
    },
    methods: {
        geOoverLength(e) {
            this.overlength = e;
        },
        setDetailView(e) {
            this.mxdiag = true;
            this.mxid = e.id.toString();
            this.mxname = e.nameDesc;
            this.mxShuizId = e.shuizId.toString();

            this.shuizFormat.forEach(item=>{
                if(e.shuizId==item.value){
                    this.mxShuizName=item.label
                }
            })
        },
        basicInfo(e) {
            // 基本信息点击事件
            this.formdata = e;
            this.childrenTitle = "编辑对比配置信息";
            this.setdiag = true;
            this.wikiType = '1';
            let params = {id: this.formdata.id}
            querySetCompany(params).then((res) => {
                if (res.data.code === "1") {
                    this.comTableData = res.data.data;
                }
            })
        },
        getdata(e){},
        createSet() {
            this.formdata = {};
            this.childrenTitle = "新建对比配置信息";
            this.setdiag = true;
            this.wikiType = '0';
        },
        addGs() {
            this.gsdiag = true;
        },
        gsclosediag() {
            this.gsdiag = false;
            const addGsInstance = this.$refs.addCompanyComponent;
            let selectData = addGsInstance.selectData;
            for (let item of selectData) {
                let filterData = this.comTableData.filter(data => data.companyCode === item.companyCode);
                if (filterData && filterData.length > 0) {
                    continue;
                }
                this.comTableData.push(item);
            }
        },
        addSet() {
            let params = JSON.parse(JSON.stringify(this.formdata))
            params.defaultFlag = params.defaultFlag ? "1" : "0";
            params.companyIdList = this.comTableData.map(data => data.id);
            if(this.wikiType == '1') {
                updateSetting(params).then((res) => {
                if (res.data.code === "1") {
                    this.$message.success("保存成功！");
                    // this.$emit('closediag', false);
                    this.comTableData = [];
                    // this.contrastSettingQuery();
                    this.closediag();
                } else {
                    this.$message.error(res.data.msg);
                }
            });
            } else {
                saveSetting(params).then((res) => {
                if (res.data.code === "1") {
                    this.$message.success("保存成功！");
                    // this.$emit('closediag', false);
                    this.comTableData = [];
                    // this.contrastSettingQuery();
                    this.closediag();
                } else {
                    this.$message.error(res.data.msg);
                }
            });
            }
        },
        deleteGs(){
            let checkRows = this.$refs.tablebox.getSelectionval();
            const addGsInstance = this.$refs.addCompanyComponent;
            if (checkRows && checkRows.length > 0) {
                checkRows.forEach(row => {
                    this.comTableData = this.comTableData.filter(item => item.companyCode !== row.companyCode && item.nsrmc !== row.nsrmc);
                    this.removeCompanyCodes.push(row.companyCode);
                    addGsInstance.selectData = addGsInstance.selectData.filter(item => item.companyCode !== row.companyCode && item.nsrmc !== row.nsrmc);
                })
            }
        },
        setDelete() {
            // 删除点击事件
            let checkRow = this.$refs.tablebox.getSelectionval();
            if (checkRow && checkRow.length > 0) {
                this.$showConfirm({
                    message: '确认删除?'
                }).then(res => {
                    if (res === 'confirm') {
                        let checkIds = checkRow.map(item => item.id);
                        let params = {idList: checkIds}
                        deleteSetting(params).then((res) => {
                            if (res.data.code === "1") {
                                this.$message.success("删除成功！");
                                this.contrastSettingQuery();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        });
                    }
                })
            } else {
                this.$message.error("请选择需要删除的数据");
            }
        },
        //初始化
        init() {
            this.getShuizList();
            this.contrastSettingQuery();
        },
        suosqchange() {
            this.pagination.pageNum = 1;
            this.pagination.paginationkey++;
            this.tablekey++;
            this.contrastSettingQuery();
        },
        contrastSettingQuery() {
            let params = JSON.parse(JSON.stringify(this.searchdata));
            params.current = this.pagination.pageNum;
            params.size = this.pagination.pageSize;
            contrastSettingPageQuery(params).then(res => {
                this.pagination.total = res.data.data.total;
                this.tableData = res.data.data.records;
                this.tableData.forEach(item => {
                    item.checked = false;
                });
                this.checked = false;
                let newarr = JSON.parse(JSON.stringify(this.tableData));
                this.tableData = newarr;
            });
        },
        getShuizList() {
            queryCompanyShuibDict().then(res => {
                this.searchlist.forEach(item => {
                    if (item.prop == 'shuizId') {
                        item.selectval = res.data.data.map(item => {
                            return {
                                label: item.reportName,
                                value: item.id
                            };
                        });
                        this.shuizFormat = item.selectval;
                    }
                });
                this.formlist.forEach(item => {
                    if (item.prop == 'shuizId') {
                        item.selectval = res.data.data.map(item => {
                            return {
                                label: item.reportName,
                                value: item.id
                            };
                        });
                    }
                });
                let newarr = JSON.parse(JSON.stringify(this.searchlist));
                this.searchlist = newarr;
            });
        },
        sizechange(e) {
            this.pagination.pageSize = e;
            this.contrastSettingQuery();
        },
        currentChange(e) {
            this.pagination.pageNum = e;
            this.contrastSettingQuery();
        },
        submitSearch() {
            this.pagination.pageNum = 1;
            this.pagination.paginationkey++;
            this.contrastSettingQuery();
        },
        forRefresh() {
            this.pagination.pageNum = 1;
            this.pagination.paginationkey++;
        },
        forUpdateSearch() {
            this.filterSearchlist = JSON.parse(JSON.stringify(this.filterSearchlist.length ? this.filterSearchlist : this.searchlist));
            this.searchdiag = true;
        },
        closeSearch() {
            this.searchdiag = false;
        },
        saveChange(e) {
            this.filterSearchlist = e;
            this.searchlist = e.filter(item => item.isshow);
            this.searchdiag = false;
        },
        confirmfilter(e) {
            this.headData = e.chooselist;
            this.outlist = e.nochooselist;
        },
        forback() {
            this.pagination.pageNum = 1;
            this.pagination.paginationkey++;
            this.contrastSettingQuery();
            this.ywgzpg = false;
        },
        closediag() {
            this.setdiag = false;
            this.contrastSettingQuery();
        }
    }
};
</script>

<style scoped lang='less'>
@import url('./index.less');
</style>
